import { createFileRoute } from "@tanstack/react-router";
import { RegisterPage } from "@/components/portal/ConsultantPortal";
import { portalMeta } from "@/lib/consultant-portal-i18n";

// Consultant portal: noindex, no hreflang/canonical alternates, excluded from sitemaps.
export const Route = createFileRoute("/tr/uzman/kayit")({
  ssr: false,
  head: () => portalMeta("Uzman kaydı", "OXORY uzman portalına kayıt olun ve onaydan sonra profilinizi yönetin."),
  component: () => <RegisterPage locale="tr" />,
});
